module.exports = __webpack_public_path__ + "static/media/damson.1661a29e.png";